import React from 'react'

import useNavigationBrandsBanner from 'modules/brands/useNavigationBrandsBanner'

import { Bone } from 'components/layout'
import { Href } from 'components/navigation'
import { BackgroundImage } from 'components/dataDisplay'

import BaseBrandsBanner from '../BaseBrandsBanner/BaseBrandsBanner'


type BrandsBannerProps = {
  type: 'perfumes' | 'colognes'
  onClick?: () => void
}

const StrapiBrandsBanner: React.FunctionComponent<BrandsBannerProps> = (props) => {
  const { isFetching, bannerData, handleClick } = useNavigationBrandsBanner(props)

  if (isFetching) {
    return (
      <Bone className="bg-gray-70" h={296} />
    )
  }

  if (!bannerData) {
    return (
      <BaseBrandsBanner {...props} />
    )
  }

  return (
    <Href to={bannerData?.to} onClick={handleClick} data-testid="brandsBanner">
      <BackgroundImage
        className="p-32 bg-gray-70 flex flex-col justify-center items-start"
        src={bannerData?.bgImage}
        style={{ backgroundPosition: '0 50%', height: '296rem' }}
      />
    </Href>
  )
}


export default StrapiBrandsBanner
